import { DataGridPro, useGridApiRef } from "@mui/x-data-grid-pro";
import { Modal } from "antd"
import { useContext } from "react"
import GeneralContext from "../../context/GeneralContext/GeneralContext";
import columns from '../../screens/control/grid_columns/patients_by_group_grid_columns'
import { displayMessage } from "../../services/helper";

const ListPatientsByLevel = ({ patientsByLevel, isModalPatientsByLevelOpen, setIsModalPatientsByLevelOpen }) => {

    const {mobile_mode} = useContext(GeneralContext)

    const gridRef = useGridApiRef()

    return (
        <Modal
            title={<div className="text-xl font-bold text-appian-blue">{displayMessage('PATIENT_LIST')}</div>}
            visible={isModalPatientsByLevelOpen}
            onCancel={() => setIsModalPatientsByLevelOpen(false)}
            centered={true}
            footer={[]}
            width={mobile_mode ? '90%' : '60%'}
            height={'80%'}
            style={{ position: 'relative' }}
            bodyStyle={{ height: mobile_mode ? '100vh' : '70vh', display: 'flex', flexDirection: 'column' }}
        >

            <div
                style={{
                    display: 'flex',
                    height: '100%'
                }}>
                <DataGridPro
                    rows={patientsByLevel ?? []}
                    initialState={{
                        sorting: {
                          sortModel: [{ field: 'patient_name', sort: 'asc' }],
                        },
                      }}
                    apiRef={gridRef}
                    style={{ flex: 1, display: 'flex' }}
                    columns={columns(mobile_mode)}
                    pagination
                    pageSize={100}
                    disableMultipleSelection
                    disableSelectionOnClick
                />
            </div>
        </Modal>
    )
}

export default ListPatientsByLevel